import qs from 'query-string';

const LIDAR_LITE_SUFFIX = '/lidarlite/';
// Main reason we need this function is to remove canary from URL
export function getLidarLiteLink(queryParams?: string | Record<string, any>) {
  if (queryParams && typeof queryParams === 'object') {
    if (queryParams.stageInstanceId) {
      // in case of stage instance id, we need to pass sceneId as stageInstanceId and not taskId
      queryParams.sceneId = queryParams.stageInstanceId;
      queryParams.taskId = undefined;
      queryParams.stageInstanceId = undefined;
    }
  }
  return (
    window.location.origin.toLowerCase().replace('canary.', '') + getLidarLitePath(queryParams)
  );
}

export function getLidarLitePath(queryParams?: string | Record<string, any>) {
  return LIDAR_LITE_SUFFIX + getQuerySuffix(queryParams);
}

function getQuerySuffix(queryParams?: string | Record<string, any>): string {
  const rawSuffix = _getQuerySuffix(queryParams);
  if (!rawSuffix.startsWith('?')) {
    return `?${rawSuffix}`;
  }
  return rawSuffix;
}

function _getQuerySuffix(queryParams?: string | Record<string, any>): string {
  if (!queryParams) {
    return '';
  }

  if (typeof queryParams === 'string') {
    return queryParams;
  }

  return qs.stringify(queryParams);
}

const VIDEO_CAPTIONING_PREFIX = '/videocaptioning/';
export function getVideoCaptioningLink(queryParams?: Record<string, any>) {
  const domain = window.location.origin.toLowerCase().replace('canary.', '').replace('/en/', '/');
  const path = getVideoCaptioningPath(queryParams);
  const query = queryParams ? `?${qs.stringify(queryParams)}` : '';
  return domain + path + query;
}
function getVideoCaptioningPath(queryParams?: Record<string, any>) {
  if (queryParams) {
    const { taskId, assignmentId } = queryParams;
    if (taskId ?? assignmentId) {
      return VIDEO_CAPTIONING_PREFIX + 'task';
    }
  }
  return VIDEO_CAPTIONING_PREFIX;
}

// TODO: use this function to redirect to the video collection page from remotasks.com/tasks
const VIDEO_COLLECTION_SUFFIX = '/videocollection/';
export function getDataCollectionV2Link(queryParams?: string | Record<string, any>) {
  const domain = window.location.origin.toLowerCase().replace('canary.', '').replace('/en/', '/');
  const path = VIDEO_COLLECTION_SUFFIX;
  const query = getQuerySuffix(queryParams);
  const finalUrl = domain + path + query;
  return finalUrl;
}
